/**
 * Exception class for errors while processing a HTTP response.
 */
export class HttpResponseException extends Error {
    payload;
    status;
    url;
    /**
     * Initializes the error instance and all its properties.
     */
    constructor(url, status, payload) {
        super(`The request to ${url} failed with status code ${status}`);
        this.name = 'HttpResponseError';
        this.url = url;
        this.payload = payload;
        this.status = status;
        // @see https://github.com/Microsoft/TypeScript/wiki/Breaking-Changes#extending-built-ins-like-error-array-and-map-may-no-longer-work
        Object.setPrototypeOf(this, HttpResponseException.prototype);
    }
}
